import { createAppAsyncThunk } from '@/domain/store.thunk';

export const signUpAskUserToCreateAccount = createAppAsyncThunk(
  'auth/signUpAskUserToCreateAccount',
  async (_, { extra: { authGateway } }) => {
    authGateway.startSignUpProcess();
  },
);
